exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clearfix:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n:host {\n  display: block;\n  border: 1px solid #bcbcbc;\n  border-radius: 4px;\n  position: relative;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.19), inset 0 0 6px rgba(0, 0, 0, 0.1);\n}\n.clear-pad-btn {\n  position: absolute;\n  top: 0.125em;\n  right: 0.75em;\n}\nsignature-pad {\n  display: block;\n}\n:host /deep/ canvas {\n  width: 100%;\n  height: 11.391em;\n  vertical-align: bottom;\n}\n.help-text {\n  text-align: center;\n  border-top: 1px solid #bcbcbc;\n  padding-bottom: 0.5em;\n  width: 94%;\n  margin-left: 3%;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/survey/signature-question/signature-question.component.less
// module id = 293
// module chunks = 1